// react
import React, { Component } from 'react';
// third-party
import classNames from 'classnames';
import PropTypes from 'prop-types';

// application
import BlockHeader from '../shared/BlockHeader';
import ProductCard from '../shared/ProductCard';
import SlickWithPreventSwipeClick from '../shared/SlickWithPreventSwipeClick';

const slickSettings = {
    'grid-4': {
        arrows: false,
        dots: false,
        infinite: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToScroll: 4,
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToScroll: 3,
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToScroll: 2,
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 479,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 1,
                },
            },
        ],
        slidesToScroll: 4,
        slidesToShow: 4,
        speed: 400,
    },
    'grid-4-sm': {
        arrows: false,
        dots: false,
        infinite: true,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToScroll: 3,
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToScroll: 2,
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 474,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 1,
                },
            },
        ],
        slidesToScroll: 4,
        slidesToShow: 4,
        speed: 400,
    },
    'grid-5': {
        arrows: false,
        dots: false,
        infinite: true,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToScroll: 4,
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToScroll: 3,
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToScroll: 2,
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 479,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 1,
                },
            },
        ],
        slidesToScroll: 5,
        slidesToShow: 5,
        speed: 400,
    },
    horizontal: {
        arrows: false,
        dots: false,
        infinite: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToScroll: 2,
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 1,
                },
            },
        ],
        slidesToScroll: 3,
        slidesToShow: 3,
        speed: 400,
    },
};

export default class BlockProductsCarousel extends Component {
    handleNextClick = () => {
        if (this.slickRef) {
            this.slickRef.slickNext();
        }
    };

    handlePrevClick = () => {
        if (this.slickRef) {
            this.slickRef.slickPrev();
        }
    };

    setSlickRef = (ref) => {
        this.slickRef = ref;
    };

    productsColumns() {
        const columns = [];
        const { rows } = this.props;
        let { products } = this.props;

        if (rows > 0) {
            products = products.slice();

            while (products.length > 0) {
                columns.push(products.splice(0, rows));
            }
        }

        return columns;
    }

    render() {
        const { groups, layout, loading, onGroupClick, title, withSidebar } = this.props;

        const blockClasses = classNames('block block-products-carousel', {
            'block-products-carousel--loading': loading,
        });
        const containerClasses = classNames({
            container: !withSidebar,
        });

        const columns = this.productsColumns().map((column, index) => {
            const products = column.map((product) => (
                <div key={product.id} className="block-products-carousel__cell">
                    <ProductCard product={product} />
                </div>
            ));

            return (
                <div key={index} className="block-products-carousel__column">
                    {products}
                </div>
            );
        });

        return (
            <div className={blockClasses} data-layout={layout}>
                <div className={containerClasses}>
                    <div id="frosmo-home-reco-1"></div>
                    <div id="frosmo-home-reco-2"></div>
                    <div id="frosmo-home-reco-3"></div>
                    <div id="frosmo-home-reco-4"></div>
                    <div id="frosmo-home-reco-5"></div>
                    <div id="frosmo-home-reco-6"></div>
                    <div id="frosmo-home-reco-7"></div>
                    <div id="frosmo-home-reco-8"></div>
                    <div id="frosmo-home-reco-9"></div>
                    <div id="frosmo-home-reco-10"></div>
                </div>
            </div>
        );
    }
}

BlockProductsCarousel.propTypes = {
    groups: PropTypes.array,
    layout: PropTypes.oneOf(['grid-4', 'grid-4-sm', 'grid-5', 'horizontal']),
    loading: PropTypes.bool,
    onGroupClick: PropTypes.func,
    products: PropTypes.array,
    rows: PropTypes.number,
    title: PropTypes.string.isRequired,
    withSidebar: PropTypes.bool,
};

BlockProductsCarousel.defaultProps = {
    groups: [],
    layout: 'grid-4',
    loading: false,
    onGroupClick: undefined,
    products: [],
    rows: 1,
    withSidebar: false,
};
